let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lyGo1")).then(() => parcelRequire('9bkHc'));